import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../../colorVars';
import { addExitTactic } from '../../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addExitTactic';
import { useWebsocketStore } from '../../../../../../../../../../stores/websocketStore/websocketProvider';
import { MultiSwitch } from '../../../../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import TextButton from '../../../../../../../../../atomic/buttons/textButton/TextButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import { greenToRedPositionsValidation } from '../../../../../../../../../forms/tradeplans/AddTradePlan/DataValidation';
import { IndividualPanelHeader } from '../../../../individualTacticPanels/IndividualPanelHeader';
import style from './IndividualAddTacticPanel.module.css';

export const AddGreenToRedPositionsTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const [headerText, setHeaderText] = useState('Add Green To Red Positions');
    const [headerTextColor, setHeaderTextColor] = useState(colors.lightGrey);
    const [details, setDetails] = useState({
      pnlTracking: 'unrealized',
      inRightDirectionPct: 0,
      retracePct: 0,
    });
    const timeoutRef = useRef(null);

    const addTactic = () => {
      const detailsCopy = { ...details };
      detailsCopy.inRightDirectionPct = details.inRightDirectionPct / 100;
      detailsCopy.retracePct = details.retracePct / 100;
      const validationResult = greenToRedPositionsValidation(detailsCopy);
      if (validationResult[0] === false) {
        setHeaderText(validationResult[1]);
        setHeaderTextColor(colors.red);
        const timer = setTimeout(() => {
          setHeaderText('Add Green To Red Positions');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      } else {
        addExitTactic(tradePlanId, {
          tactic: 'GREEN_TO_RED_POSITIONS',
          details: detailsCopy,
        });
        setHeaderText('Green To Red Positions Added');
        setHeaderTextColor(colors.green);
        const timer = setTimeout(() => {
          setHeaderText('Add Green To Red Positions');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      }
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, []);

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                {/* <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    PnL Tracking
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <MultiSwitch
                    margin="5px 0 0 0"
                    labels={['Unrealized', 'Overall']}
                    values={['unrealized', 'overall']}
                    controlledValue={details.pnlTracking}
                    setValue={(value) =>
                      setDetails((prev) => ({ ...prev, pnlTracking: value }))
                    }
                  />
                </td> */}
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Right Direction %
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.inRightDirectionPct}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          inRightDirectionPct: newValue,
                        }))
                      }
                    />
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </div>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Retrace %
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.retracePct}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          retracePct: newValue,
                        }))
                      }
                    />
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <header className={style.header}>
            <Body3 color={headerTextColor} fontWeight={700}>
              {headerText}
            </Body3>
            <TextButton
              disabled={
                tradePlan.exitTactics['GREEN_TO_RED_POSITIONS'] !== undefined
              }
              color={colors.lightGrey}
              backgroundColor={
                tradePlan.exitTactics['GREEN_TO_RED_POSITIONS']
                  ? colors.grey
                  : colors.blue
              }
              fontSize="small"
              clickHandler={addTactic}
              width="20%"
              height="50%"
            >
              Add
            </TextButton>
          </header>
        </div>
      </TabPanel>
    );
  }
);

AddGreenToRedPositionsTacticPanel.tabsRole = 'TabPanel';
